module.exports = __webpack_public_path__ + "static/media/hero-store-in-store.2a62d025.jpg";